
const SVILA_WISHLIST_KEY = 'svila_wishlist';
function svilaEscapeHTML(value){return String(value??'').replace(/[&<>"']/g,(c)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
function svilaEscapeAttr(value){return svilaEscapeHTML(value).replace(/`/g,'&#96;');}
function svilaReadWishlist(){try{const parsed=JSON.parse(localStorage.getItem(SVILA_WISHLIST_KEY)||'[]');return Array.isArray(parsed)?parsed:(parsed&&Array.isArray(parsed.items)?parsed.items:[])}catch(e){return[]}}
function svilaNormalizeWishlistItem(item){if(!item)return null;if(typeof item==='number')return{id:`id:${item}`,productId:String(item),handle:'',title:'Mėgstama prekė',url:'#',image:'',price:''};if(typeof item==='string'){const h=item.replace('/products/','').split('?')[0].split('/').filter(Boolean).pop()||item;return{id:`handle:${h}`,productId:'',handle:h,title:h,url:`/products/${h}`,image:'',price:''}}if(typeof item!=='object')return null;const productId=item.productId||item.product_id||item.id||'';const raw=item.handle||item.productHandle||item.product_handle||item.slug||item.url||item.href||'';const handle=String(raw||'').replace('/products/','').split('?')[0].split('/').filter(Boolean).pop()||String(raw||'');const id=productId?`id:${productId}`:(handle?`handle:${handle}`:'');if(!id)return null;return{id,productId:String(productId||''),handle,title:item.title||item.productTitle||item.product_title||handle||'Mėgstama prekė',url:item.url||item.href||(handle?`/products/${handle}`:'#'),image:item.image||item.featured_image||item.featuredImage||item.img||'',price:item.priceText||item.price_text||item.price||''}}
function svilaNormalizeWishlistList(rawItems=svilaReadWishlist()){const map=new Map();rawItems.forEach((raw)=>{const item=svilaNormalizeWishlistItem(raw);if(item&&item.id&&!map.has(item.id))map.set(item.id,item)});return Array.from(map.values())}
function updateWishlistHeaderCount(){const count=svilaNormalizeWishlistList().length;$$('[data-wishlist-count]').forEach((el)=>{el.textContent=String(count);el.hidden=count<=0;el.style.display=count>0?'flex':'none'})}
function svilaSaveWishlist(items){const normalized=svilaNormalizeWishlistList(items);localStorage.setItem(SVILA_WISHLIST_KEY,JSON.stringify(normalized));updateWishlistHeaderCount();document.dispatchEvent(new CustomEvent('wishlist:sync',{detail:{items:normalized}}))}
class Wishlist{constructor(){this.items=svilaNormalizeWishlistList();this.init()}init(){this.bindButtons();this.updateButtons();this.updateHeaderCount()}bindButtons(){$$('[data-wishlist], .js-wishlist').forEach((button)=>{if(button.dataset.wishlistBound==='true')return;button.dataset.wishlistBound='true';button.addEventListener('click',(event)=>{if(button.matches('a.wishlist-header-btn[href], a[href="/pages/megstami"]'))return;event.preventDefault();this.toggleFromButton(button)})})}itemFromButton(button){return svilaNormalizeWishlistItem({id:button.dataset.wishlistId||button.dataset.productId||button.dataset.id||'',productId:button.dataset.wishlistId||button.dataset.productId||button.dataset.id||'',handle:button.dataset.wishlistHandle||button.dataset.handle||button.dataset.productHandle||'',title:button.dataset.wishlistTitle||button.dataset.title||button.getAttribute('aria-label')||'',url:button.dataset.wishlistUrl||'',image:button.dataset.wishlistImage||'',price:button.dataset.wishlistPrice||''})}has(item){return!!item&&this.items.some((existing)=>existing.id===item.id)}toggleFromButton(button){const item=this.itemFromButton(button);if(!item||!item.id)return;if(this.has(item)){this.items=this.items.filter((existing)=>existing.id!==item.id);window.svilaShowToast?.('Pašalinta iš mėgstamų',false,1800)}else{this.items=[...this.items,item];window.svilaShowToast?.('Pridėta į mėgstamus',false,1800)}svilaSaveWishlist(this.items);this.items=svilaNormalizeWishlistList();this.updateButtons()}updateButtons(){$$('[data-wishlist], .js-wishlist').forEach((button)=>{const item=this.itemFromButton(button);const active=this.has(item);button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active))})}updateHeaderCount(){updateWishlistHeaderCount()}}
async function svilaFetchWishlistProduct(item){if(!item.handle)return item;try{const res=await fetch(`/products/${encodeURIComponent(item.handle)}.js`);if(!res.ok)return item;const product=await res.json();return{...item,id:item.productId?`id:${item.productId}`:(product.id?`id:${product.id}`:item.id),productId:String(item.productId||product.id||''),handle:product.handle||item.handle,title:product.title||item.title,url:product.url||`/products/${product.handle||item.handle}`,image:product.featured_image||(product.images&&product.images[0])||item.image||'',price:typeof product.price==='number'?new Intl.NumberFormat(document.documentElement.lang||'lt-LT',{style:'currency',currency:'EUR'}).format(product.price/100):item.price}}catch(e){return item}}
function svilaRenderWishlistSkeleton(grid){grid.innerHTML=Array.from({length:4}).map(()=>`<article class="wishlist-page-card wishlist-page-card--skeleton" aria-hidden="true"><div class="wishlist-page-card__media"></div><div class="wishlist-page-card__body"><div class="skeleton-line skeleton-line--title"></div><div class="skeleton-line skeleton-line--short"></div></div></article>`).join('')}
async function renderWishlistPage(){const grid=document.querySelector('[data-wishlist-page-grid]');const empty=document.querySelector('[data-wishlist-page-empty]');const summary=document.querySelector('[data-wishlist-summary]');if(!grid)return;grid.setAttribute('aria-busy','true');svilaRenderWishlistSkeleton(grid);let items=svilaNormalizeWishlistList();if(!items.length){grid.innerHTML='';grid.setAttribute('aria-busy','false');if(empty)empty.hidden=false;if(summary)summary.textContent='Kol kas neturite išsaugotų prekių.';return}if(summary)summary.textContent='Kraunamos mėgstamos prekės...';items=await Promise.all(items.map(async(item)=>{const needs=item.handle&&(!item.image||!item.price||item.title===item.handle||item.url==='#');return needs?await svilaFetchWishlistProduct(item):item}));items=svilaNormalizeWishlistList(items);localStorage.setItem(SVILA_WISHLIST_KEY,JSON.stringify(items));updateWishlistHeaderCount();grid.innerHTML='';grid.setAttribute('aria-busy','false');if(empty)empty.hidden=true;if(summary)summary.textContent=`Išsaugota prekių: ${items.length}`;items.forEach((item)=>{const title=svilaEscapeHTML(item.title||item.handle||'Mėgstama prekė');const url=svilaEscapeAttr(item.url||(item.handle?`/products/${item.handle}`:'#'));const image=svilaEscapeAttr(item.image||'');const price=svilaEscapeHTML(item.price||'');const id=svilaEscapeAttr(item.id);const card=document.createElement('article');card.className='wishlist-page-card';card.dataset.wishlistId=item.id;const imageMarkup=image?`<a class="wishlist-page-card__media" href="${url}"><img src="${image}" alt="${title}" loading="lazy"></a>`:`<a class="wishlist-page-card__media wishlist-page-card__media--empty" href="${url}" aria-label="${title}"><span aria-hidden="true">♡</span></a>`;card.innerHTML=`${imageMarkup}<div class="wishlist-page-card__body"><h3><a href="${url}">${title}</a></h3>${price?`<p class="wishlist-page-card__price">${price}</p>`:''}<div class="wishlist-page-card__actions"><a class="btn btn-secondary" href="${url}">Peržiūrėti</a><button type="button" class="btn btn-ghost" data-wishlist-remove-id="${id}">Pašalinti</button></div></div>`;grid.appendChild(card)});grid.querySelectorAll('[data-wishlist-remove-id]').forEach((btn)=>{btn.addEventListener('click',()=>{const removeId=btn.dataset.wishlistRemoveId;svilaSaveWishlist(svilaNormalizeWishlistList().filter((item)=>item.id!==removeId));renderWishlistPage()})})}

/**
 * Švila — theme.js
 * Core Shopify interactions. All dynamic innerHTML values are escaped
 * through escapeHTML() to prevent XSS from user-controlled content
 * (product titles, variant titles, property keys/values, image alts, URLs).
 */

'use strict';

const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];



/**
 * Format cents as €X,XX. Returns empty string if input is not a finite number.
 * Predictive search and recommendations API may return price as a string
 * like "19.99" (dollars, not cents) or null. safeMoney detects these cases.
 */
const money = (cents) => {
  const n = Number(cents);
  if (!Number.isFinite(n)) return '';
  const amount = (n / 100).toFixed(2).replace('.', ',');
  return `\u20AC${amount}`;
};

/**
 * Format a value that might be cents (integer) or a decimal-dollar string
 * (from search/suggest.json which returns "19.99" not 1999).
 * Heuristic: if the value looks like it already has a decimal portion that
 * makes it < 1000 and contains a dot, treat it as dollars; otherwise cents.
 */
const safeMoney = (val) => {
  if (val == null) return '';
  const s = String(val).trim();
  if (s === '' || s === '0') return '';
  const n = Number(s);
  if (!Number.isFinite(n)) return escapeHTML(s);
  // Predictive search returns "19.99" (dollars). Variant objects return 1999 (cents).
  // If the raw string contains a dot and the number is < 10000, it's likely dollars.
  if (s.includes('.') && n < 10000) {
    return `\u20AC${n.toFixed(2).replace('.', ',')}`;
  }
  return money(n);
};

/**
 * Covers: product titles, variant titles, property keys/values,
 * image alt text, item keys (used in data attributes), and URLs.
 */
function escapeHTML(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Escape a value for safe use inside an HTML attribute (data-key, src, alt). */
function escapeAttr(str) {
  return escapeHTML(str);
}

/* ============================================================
   CART
============================================================ */
class SvilaCart {
  constructor() {
    this.drawer    = $('#cart-drawer');
    this.backdrop  = $('#cart-backdrop');
    this.itemsList = $('#cart-items');
    this.footerEl  = $('#cart-footer');
    this.countEls  = $$('.cart-dot');
    this.subtotalEl = $('#cart-subtotal');
    this.init();
  }

  init() {
    $('#cart-toggle')?.addEventListener('click', () => this.open());
    $('#cart-close')?.addEventListener('click', () => this.close());
    this.backdrop?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer?.classList.contains('is-open')) this.close();
    });
    this.drawer?.addEventListener('click', (e) => {
      const minusBtn  = e.target.closest('.cart-qty-minus');
      const plusBtn   = e.target.closest('.cart-qty-plus');
      const removeBtn = e.target.closest('.cart-item__remove');
      if (minusBtn)  this.updateItem(minusBtn.dataset.key, -1);
      if (plusBtn)   this.updateItem(plusBtn.dataset.key, +1);
      if (removeBtn) this.removeItem(removeBtn.dataset.key);
    });

    document.addEventListener('click', async (e) => {
      if (e.target.closest('#cart-drawer')) return;
      const minusBtn  = e.target.closest('.cart-qty-minus');
      const plusBtn   = e.target.closest('.cart-qty-plus');
      const removeBtn = e.target.closest('.cart-item__remove');
      if (!minusBtn && !plusBtn && !removeBtn) return;

      e.preventDefault();
      if (minusBtn)  await this.updateItem(minusBtn.dataset.key, -1);
      if (plusBtn)   await this.updateItem(plusBtn.dataset.key, +1);
      if (removeBtn) await this.removeItem(removeBtn.dataset.key);

      if (document.querySelector('.cart-page-wrap')) {
        window.location.reload();
      }
    });
  }

  open() {
    document.body.classList.add('cart-drawer-open');
    document.dispatchEvent(new CustomEvent('cart:open'));
    this.drawer?.setAttribute('aria-hidden', 'false');
    this.drawer?.classList.add('is-open');
    this.backdrop?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    $('#cart-close')?.focus();
    $('#cart-toggle')?.setAttribute('aria-expanded', 'true');
  }

  close() {
    document.body.classList.remove('cart-drawer-open');
    document.dispatchEvent(new CustomEvent('cart:close'));
    this.drawer?.setAttribute('aria-hidden', 'true');
    this.drawer?.classList.remove('is-open');
    this.backdrop?.classList.remove('is-visible');
    document.body.style.overflow = '';
    $('#cart-toggle')?.setAttribute('aria-expanded', 'false');
  }

  async add(variantId, quantity = 1, properties = {}) {
    return this.addItems([{ id: variantId, quantity, properties }]);
  }

  async addItems(items = []) {
    try {
      const cleanItems = items
        .filter(item => item && item.id && Number(item.quantity || 0) > 0)
        .map(item => ({
          id: Number(item.id),
          quantity: Number(item.quantity || 1),
          properties: item.properties || {}
        }));
      if (!cleanItems.length) return;

      const body = cleanItems.length === 1 ? cleanItems[0] : { items: cleanItems };
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error(await res.text());
      const added = await res.json();
      await this.refresh();
      this.open();
      this.showToast(cleanItems.length > 1 ? 'Prekės įdėtos į krepšelį' : 'Prekė įdėta į krepšelį');
      return added;
    } catch (err) {
      console.error('Cart add error:', err);
      this.showToast('Nepavyko įdėti į krepšelį', 'error');
    }
  }

  isBundleAddon(item) {
    const props = item?.properties || {};
    return Boolean(props['Priedas prie'] || props['Priedo tipas']);
  }

  getBundleId(item) {
    return item?.properties?.['Rinkinio ID'] || '';
  }

  async updateItem(key, delta) {
    const cart = await fetch('/cart.js').then(r => r.json());
    const item = cart.items.find(i => i.key === key);
    if (!item) return;
    await this.setItemQuantity(item, Math.max(0, item.quantity + delta), cart);
  }

  async setItemQuantity(item, quantity, cart = null) {
    const bundleId = this.getBundleId(item);
    const isMainBundleItem = bundleId && !this.isBundleAddon(item);

    if (isMainBundleItem) {
      const currentCart = cart || await fetch('/cart.js').then(r => r.json());
      const updates = {};
      currentCart.items
        .filter(i => this.getBundleId(i) === bundleId)
        .forEach(i => { updates[i.key] = quantity; });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    } else {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity })
      });
    }

    await this.refresh();
  }

  async changeQty(key, quantity) {
    const cart = await fetch('/cart.js').then(r => r.json());
    const item = cart.items.find(i => i.key === key);
    if (!item) return;
    await this.setItemQuantity(item, quantity, cart);
  }

  async removeItem(key) { await this.changeQty(key, 0); }

  async refresh() {
    const cart = await fetch('/cart.js').then(r => r.json());
    this.updateCount(cart.item_count);
    this.renderItems(cart);
    this.updateFooter(cart);
    this.updateShippingBar(cart.total_price);
  }

  renderItems(cart) {
    if (!this.itemsList) return;
    if (cart.item_count === 0) {
      this.itemsList.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p>Krepšelis tuščias</p>' +
          '<a href="/collections/all" class="btn btn-primary">Tęsti apsipirkimą</a>' +
        '</div>';
      return;
    }
    this.itemsList.innerHTML = cart.items.map(item => {
      const safeTitle   = escapeHTML(item.product_title);
      const safeVariant = escapeHTML(item.variant_title);
      const safeAlt     = escapeAttr(item.title);
      const safeKey     = escapeAttr(item.key);
      const imgSrc      = item.image
        ? escapeAttr(item.image.replace(/(\.\w+)(\?|$)/, '_100x100$1$2'))
        : '';
      const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div class="cart-item__variant">${safeVariant}</div>` : '';
      const propsHtml = Object.entries(item.properties || {})
        .filter(([k, v]) => v && k !== 'Rinkinio ID' && k !== 'Pagrindinės prekės variantas')
        .map(([k, v]) => {
          const addonClass = ['Priedas prie', 'Priedo tipas', 'Pasirinkti priedai'].includes(k) ? ' cart-item__property--addon' : '';
          return `<div class="cart-item__property${addonClass}"><span>${escapeHTML(k)}:</span> ${escapeHTML(v)}</div>`;
        })
        .join('');
      return `
      <div class="cart-item" data-key="${safeKey}">
        <div class="cart-item__img">
          ${imgSrc ? `<img src="${imgSrc}" alt="${safeAlt}" width="80" height="80" loading="lazy"/>` : ''}
        </div>
        <div class="cart-item__info">
          <div class="cart-item__title">${safeTitle}</div>
          ${variantHtml}${propsHtml}
          <div class="cart-item__row">
            <div class="cart-item__qty">
              <button class="qty-b cart-qty-minus" data-key="${safeKey}">−</button>
              <span class="cart-item__qty-val">${item.quantity}</span>
              <button class="qty-b cart-qty-plus" data-key="${safeKey}">+</button>
            </div>
            <div class="cart-item__price">${money(item.final_line_price)}</div>
            <button class="cart-item__remove" data-key="${safeKey}">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>`;
    }).join('');
  }

  updateFooter(cart) {
    if (!this.footerEl) return;
    if (cart.item_count > 0) {
      this.footerEl.style.display = '';
      if (this.subtotalEl) this.subtotalEl.textContent = money(cart.total_price);
    } else {
      this.footerEl.style.display = 'none';
    }
  }

  updateCount(count) {
    this.countEls.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  updateShippingBar(totalPrice) {
    const bar = $('#shipping-bar');
    if (!bar) return;
    const threshold = 50 * 100;
    const remaining = Math.max(0, threshold - totalPrice);
    const pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
    if (totalPrice >= threshold) {
      bar.innerHTML = '<p class="shipping-bar__msg shipping-bar__msg--done">🎉 Turite nemokamą pristatymą!</p>';
    } else {
      bar.innerHTML =
        '<p class="shipping-bar__msg">' + money(remaining) + ' iki nemokamo pristatymo</p>' +
        '<div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:' + pct + '%"></div></div>';
    }
  }

  showToast(message, type = 'success') {
    const toast = $('#svila-toast');
    if (!toast) return;
    toast.textContent = '';
    toast.insertAdjacentText('beforeend', message);
    toast.className = `svila-toast svila-toast--${type} svila-toast--visible`;
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => toast.classList.remove('svila-toast--visible'), 2800);
  }
}

/* ============================================================
   PRODUCT FORM
============================================================ */

class AddonManager {
  constructor(root = document) {
    this.root = root;
    this.checkboxes = Array.from(root.querySelectorAll('.js-addon-option'));
    this.init();
  }

  init() {
    this.checkboxes.forEach((checkbox) => {
      this.syncField(checkbox);
      checkbox.addEventListener('change', () => this.syncField(checkbox));
    });
  }

  syncField(checkbox) {
    const targetId = checkbox.getAttribute('aria-controls') || checkbox.dataset.target;
    if (!targetId) return;
    const field = document.getElementById(targetId);
    if (!field) return;
    const checked = checkbox.checked;
    field.hidden = !checked;
    checkbox.setAttribute('aria-expanded', String(checked));
    const textarea = field.querySelector('textarea, input, select');
    if (textarea) {
      if (checked) {
        textarea.removeAttribute('tabindex');
      } else {
        textarea.setAttribute('tabindex', '-1');
      }
    }
  }

  selectedTotalCents() {
    return this.checkboxes.reduce((total, checkbox) => {
      if (!checkbox.checked) return total;
      const price = Number(checkbox.dataset.price || checkbox.dataset.priceCents || 0);
      return total + (Number.isFinite(price) ? price : 0);
    }, 0);
  }
}

class PriceCalculator {
  constructor(root = document) {
    this.root = root;
    this.button = root.querySelector('#add-to-cart, [data-add-to-cart]');
    this.priceTarget = root.querySelector('#cart-price, [data-cart-price]');
  }

  format(cents) {
    const value = Number(cents || 0);
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(value);
      }
    } catch (error) {}
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'lt-LT', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(value / 100);
    } catch (error) {
      return `€${(value / 100).toFixed(2).replace('.', ',')}`;
    }
  }

  update(baseCents, addonCents = 0) {
    const total = Number(baseCents || 0) + Number(addonCents || 0);
    const formatted = this.format(total);
    if (this.priceTarget) this.priceTarget.textContent = formatted;
    if (this.button && this.button.dataset.defaultText) {
      this.button.textContent = `${this.button.dataset.defaultText} — ${formatted}`;
    }
    if (this.button) this.button.dataset.currentPrice = String(total);
  }
}

class ProductForm {
  constructor(form) {
    if (!form) return;
    this.form        = form;
    this.productData = this.parseProductData();
    this.variantInput = $('#variant-id-input', form) || $('[name="id"]', form);
    this.mainPriceEl = $('#product-price');
    this.atcBtn      = $('#add-to-cart', form);
    this.currentVariant = null;
    this.init();
  }

  parseProductData() {
    const el = $('#product-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  init() {
    const optContainer = this.form.closest('.pdp-grid') || document;
    $$('.v-opts', optContainer).forEach(group => {
      $$('.v-opt', group).forEach(btn => {
        btn.addEventListener('click', () => {
          $$('.v-opt', group).forEach(b => {
            b.classList.remove('on');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('on');
          btn.setAttribute('aria-checked', 'true');
          this.updateVariant();
        });
      });
    });

    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!this.atcBtn || this.atcBtn.disabled) return;

      if (!this.validateRequiredFields()) return;

      const variantId  = parseInt(this.variantInput?.value);
      const quantity   = parseInt($('#qty-v')?.value || $('[name="quantity"]', this.form)?.value || '1');
      const properties = this.collectProperties();
      const selectedAddonLabels = $$('.js-addon-option[data-addon-variant-id]', this.form)
        .filter(cb => cb.checked && cb.dataset.addonVariantId)
        .map(cb => cb.dataset.addonTitle || cb.closest('.perso-opt')?.querySelector('.perso-chk span')?.textContent?.trim())
        .filter(Boolean);

      const groupId = selectedAddonLabels.length
        ? `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
        : '';

      if (selectedAddonLabels.length) {
        properties['Pasirinkti priedai'] = selectedAddonLabels.join(', ');
        properties['Rinkinio ID'] = groupId;
      }

      const addonItems = this.collectAddonItems(quantity, properties, groupId);
      const items = [{ id: variantId, quantity, properties }, ...addonItems];

      const original = this.atcBtn.innerHTML;
      const addLabel = this.atcBtn.dataset.addLabel || 'Į krepšelį';
      try {
        this.setLoading(true);
        await window.svilaCart?.addItems(items);
        const addedLabel = this.atcBtn.dataset.addedLabel || 'Pridėta';
        this.atcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> ' + escapeHTML(addedLabel);
        this.atcBtn.classList.add('is-added');
        setTimeout(() => {
          this.atcBtn.classList.remove('is-added');
          this.atcBtn.innerHTML = original || escapeHTML(addLabel);
          this.setLoading(false);
          this.updateDisplayedPrices();
    this.initStickyBuyBar();
        }, 1600);
      } catch (err) {
        console.error('Product add error:', err);
        this.setLoading(false);
        this.atcBtn.innerHTML = original || escapeHTML(addLabel);
        window.svilaCart?.showToast?.('Įvyko klaida. Bandykite dar kartą.', 'error');
      }
    });

    this.initPersonalization('chk-card',  'field-card',  'ta-card',  'cnt-card');
    this.initPersonalization('chk-label', 'field-label', 'ta-label', 'cnt-label');
    this.initQty();
    this.updateDisplayedPrices();
    this.initStickyBuyBar();
  }

  setLoading(isLoading) {
    if (!this.atcBtn) return;
    this.atcBtn.classList.toggle('is-loading', Boolean(isLoading));
    this.atcBtn.disabled = Boolean(isLoading);
    this.atcBtn.setAttribute('aria-busy', String(Boolean(isLoading)));
    if (isLoading) {
      this.atcBtn.innerHTML = '<span class="btn-spinner" aria-hidden="true"></span><span>Dedama į krepšelį...</span>';
    }
  }

  validateRequiredFields() {
    const engraving = $('.engraving-field textarea[required]', this.form);
    if (engraving && !engraving.value.trim()) {
      engraving.focus();
      window.svilaCart?.showToast?.('Įrašykite graviūros tekstą.', 'error');
      return false;
    }
    const activeInvalidAddon = $$('.js-addon-option', this.form).find(cb => {
      if (!cb.checked) return false;
      const fieldId = cb.getAttribute('aria-controls');
      const field = fieldId ? document.getElementById(fieldId) : null;
      const requiredText = field?.querySelector('textarea[required]');
      return requiredText && !requiredText.value.trim();
    });
    if (activeInvalidAddon) {
      const field = document.getElementById(activeInvalidAddon.getAttribute('aria-controls'));
      field?.querySelector('textarea')?.focus();
      window.svilaCart?.showToast?.('Užpildykite pasirinkto priedo tekstą.', 'error');
      return false;
    }
    return true;
  }

  collectProperties() {
    const props = {};
    const form = this.form;
    $$('input[type="checkbox"][name^="properties["]', form).forEach(cb => {
      if (!cb.checked) return;
      const key = cb.name.match(/properties\[(.+)\]/)?.[1];
      if (key) props[key] = cb.value;
    });
    $$('textarea[name^="properties["]', form).forEach(ta => {
      const key = ta.name.match(/properties\[(.+)\]/)?.[1];
      if (!key || !ta.value.trim()) return;
      const container = ta.closest('.perso-opt');
      if (!container) {
        props[key] = ta.value.trim();
        return;
      }
      const checkbox = container.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        props[key] = ta.value.trim();
      }
    });
    return props;
  }

  collectAddonItems(quantity, mainProperties = {}, groupId = '') {
    const productTitle = document.querySelector('.p-title')?.textContent?.trim() || '';
    const mainVariantId = this.variantInput?.value || '';

    return $$('.js-addon-option[data-addon-variant-id]', this.form)
      .filter(cb => cb.checked && cb.dataset.addonVariantId)
      .map(cb => {
        const addonTitle = cb.dataset.addonTitle || cb.closest('.perso-opt')?.querySelector('.perso-chk span')?.textContent?.trim() || 'Priedas';
        const addonProps = {
          'Priedo tipas': addonTitle,
          'Priedas prie': productTitle,
          'Pagrindinės prekės variantas': mainVariantId,
          'Rinkinio ID': groupId
        };

        if (cb.dataset.addonKind === 'greeting_card') {
          if (mainProperties['Kortelės tekstas']) addonProps['Kortelės tekstas'] = mainProperties['Kortelės tekstas'];
          if (mainProperties['Card message']) addonProps['Card message'] = mainProperties['Card message'];
        }

        if (cb.dataset.addonKind === 'custom_label') {
          if (mainProperties['Etiketės tekstas']) addonProps['Etiketės tekstas'] = mainProperties['Etiketės tekstas'];
          if (mainProperties['Label text']) addonProps['Label text'] = mainProperties['Label text'];
        }

        return {
          id: Number(cb.dataset.addonVariantId),
          quantity,
          properties: addonProps
        };
      });
  }

  updateVariant() {
    if (!this.productData) return;
    const selectedOptions = [];
    $$('[data-option-position]').forEach(group => {
      const active = $('.v-opt.on', group);
      if (active) selectedOptions[parseInt(group.dataset.optionPosition) - 1] = active.dataset.value;
    });
    const variant = this.productData.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
    if (!variant) return;

    this.currentVariant = variant;
    if (this.variantInput) this.variantInput.value = variant.id;

    try {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    } catch (err) {
      /* URL update is non-critical, especially inside Shopify theme editor previews. */
    }

    if (this.mainPriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.mainPriceEl.innerHTML =
          '<span class="prod-card__price prod-card__price--sale">' + money(variant.price) + '</span>' +
          '<span class="prod-card__compare-price">' + money(variant.compare_at_price) + '</span>';
      } else {
        this.mainPriceEl.innerHTML =
          '<span class="prod-card__price">' + money(variant.price) + '</span>';
      }
    }

    if (this.atcBtn) {
      if (variant.available) {
        this.atcBtn.disabled = false;
        this.updateDisplayedPrices(variant);
      } else {
        const soldOutLabel = this.atcBtn.dataset.soldOutLabel || 'Šiuo metu neturime';
        this.atcBtn.disabled = true;
        this.atcBtn.textContent = soldOutLabel;
      }
    }

    if (variant.featured_image) {
      const mainImg = $('#gal-main-img');
      if (mainImg) {
        mainImg.src = variant.featured_image.src;
        $$('.g-thumb').forEach(thumb => {
          thumb.classList.toggle('on', thumb.dataset.img === variant.featured_image.src);
        });
      }
    }
  }

  getSelectedAddonTotal() {
    return $$('.js-addon-option[data-addon-variant-id]', this.form)
      .filter(cb => cb.checked)
      .reduce((sum, cb) => sum + (parseInt(cb.dataset.addonPrice || '0', 10) || 0), 0);
  }

  getCurrentVariant() {
    if (this.currentVariant) return this.currentVariant;
    const variantId = parseInt(this.variantInput?.value || '0', 10);
    if (this.productData?.variants?.length) {
      return this.productData.variants.find(v => v.id === variantId) || this.productData.variants[0];
    }
    const priceText = $('#cart-price')?.textContent || '';
    return { id: variantId, price: 0, available: true, _priceText: priceText };
  }

  updateDisplayedPrices(variant = null) {
    const activeVariant = variant || this.getCurrentVariant();
    if (!activeVariant || !this.atcBtn) return;

    const qtyInput = $('#qty-v') || $('[name="quantity"]', this.form);
    const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
    const addonTotal = this.getSelectedAddonTotal();

    if (activeVariant.price) {
      const unitTotal = activeVariant.price + addonTotal;
      const total = unitTotal * qty;
      const cartPriceEl = $('#cart-price');

      if (cartPriceEl) {
        cartPriceEl.textContent = money(total);
      } else if (!this.atcBtn.disabled) {
        const addLabel = this.atcBtn.dataset.addLabel || 'Į krepšelį';
        this.atcBtn.innerHTML = escapeHTML(addLabel) + ' — <span id="cart-price">' + money(total) + '</span>';
      }

      if (this.mainPriceEl) {
        if (addonTotal > 0) {
          this.mainPriceEl.innerHTML =
            '<span class="prod-card__price">' + money(activeVariant.price) + '</span>' +
            '<span class="p-price__addon"> + priedai ' + money(addonTotal) + '</span>';
        } else if (activeVariant.compare_at_price && activeVariant.compare_at_price > activeVariant.price) {
          this.mainPriceEl.innerHTML =
            '<span class="prod-card__price prod-card__price--sale">' + money(activeVariant.price) + '</span>' +
            '<span class="prod-card__compare-price">' + money(activeVariant.compare_at_price) + '</span>';
        } else {
          this.mainPriceEl.innerHTML =
            '<span class="prod-card__price">' + money(activeVariant.price) + '</span>';
        }
      }
    }
  }

  initPersonalization(checkId, fieldId, taId, countId) {
    const chk   = $(`#${checkId}`);
    const field = $(`#${fieldId}`);
    if (!chk || !field) return;
    const sync = () => {
      field.hidden = !chk.checked;
      chk.setAttribute('aria-expanded', String(chk.checked));
      this.updateDisplayedPrices();
    };
    chk.addEventListener('change', sync);
    sync();
    const ta  = $(`#${taId}`);
    const cnt = $(`#${countId}`);
    if (ta && cnt) {
      ta.addEventListener('input', () => { cnt.textContent = ta.value.length; });
    }
  }

  initStickyBuyBar() {
    const stickyBar = $('#sticky-buy-bar');
    const stickyBtn = $('#sticky-add-to-cart');
    const stickyPrice = $('#sticky-price');
    if (!stickyBar || !stickyBtn) return;
    if (this._stickyBuyBarInitialized) return;
    this._stickyBuyBarInitialized = true;

    const updateStickyState = () => {
      const cartPrice = $('#cart-price') || $('[data-cart-price]');
      const mainBtn = this.atcBtn || this.addButton || $('#add-to-cart') || $('[data-add-to-cart]');
      if (cartPrice && stickyPrice) stickyPrice.textContent = cartPrice.textContent;
      if (mainBtn) {
        stickyBtn.disabled = !!mainBtn.disabled;
        stickyBtn.setAttribute('aria-disabled', String(!!mainBtn.disabled));
      }
      stickyBar.hidden = false;
    };

    if (!this._stickyPriceWrapped && typeof this.updateDisplayedPrices === 'function') {
      const originalUpdateDisplayedPrices = this.updateDisplayedPrices.bind(this);
      this.updateDisplayedPrices = (...args) => {
        const result = originalUpdateDisplayedPrices(...args);
        updateStickyState();
        return result;
      };
      this._stickyPriceWrapped = true;
    }

    stickyBtn.addEventListener('click', () => {
      const mainBtn = this.atcBtn || this.addButton || $('#add-to-cart') || $('[data-add-to-cart]');
      if (!mainBtn || mainBtn.disabled) return;
      mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => mainBtn.click(), 450);
    });

    document.addEventListener('cart:open', () => { stickyBar.hidden = true; });
    document.addEventListener('cart:close', updateStickyState);
    setTimeout(updateStickyState, 200);
  }

  initQty() {
    const minus = $('#qty-minus');
    const plus  = $('#qty-plus');
    const val   = $('#qty-v');
    if (!val) return;
    const updateAtcPrice = () => this.updateDisplayedPrices();
    minus?.addEventListener('click', () => {
      const cur = parseInt(val.value) || 1;
      if (cur > 1) { val.value = cur - 1; updateAtcPrice(); }
    });
    plus?.addEventListener('click', () => {
      const cur = parseInt(val.value) || 1;
      if (cur < 99) { val.value = cur + 1; updateAtcPrice(); }
    });
    val.addEventListener('input', updateAtcPrice);
  }
}

/* ============================================================
   GALLERY
============================================================ */
class ProductGallery {
  constructor() {
    this.mainImg = $('#gal-main-img');
    this.thumbs  = $$('.g-thumb');
    this.prev    = $('#gal-prev');
    this.next    = $('#gal-next');
    this.zoomBtn = $('#gal-zoom');

    this.lightbox = $('#product-lightbox');
    this.lightboxImg = $('#product-lightbox-img');
    this.lightboxClose = $('#product-lightbox-close');
    this.lightboxPrev = $('#product-lightbox-prev');
    this.lightboxNext = $('#product-lightbox-next');
    this.lastFocused = null;
    this.focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    this.cur = 0;
    this.images = this.thumbs.map((thumb) => ({
      src: thumb.dataset.img || '',
      full: thumb.dataset.full || thumb.dataset.img || ''
    }));

    if (!this.images.length && this.mainImg) {
      this.images = [{
        src: this.mainImg.currentSrc || this.mainImg.src,
        full: this.mainImg.dataset.full || this.mainImg.currentSrc || this.mainImg.src
      }];
    }

    if (!this.mainImg) return;
    this.init();
  }

  init() {
    this.thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => this.goTo(i));
    });

    this.prev?.addEventListener('click', () => this.goTo(this.cur - 1));
    this.next?.addEventListener('click', () => this.goTo(this.cur + 1));

    this.zoomBtn?.addEventListener('click', () => this.openLightbox());
    this.mainImg?.addEventListener('dblclick', () => this.openLightbox());

    this.lightboxClose?.addEventListener('click', () => this.closeLightbox());
    this.lightbox?.addEventListener('click', (e) => {
      if (e.target === this.lightbox) this.closeLightbox();
    });
    this.lightboxPrev?.addEventListener('click', () => this.goTo(this.cur - 1, true));
    this.lightboxNext?.addEventListener('click', () => this.goTo(this.cur + 1, true));

    document.addEventListener('keydown', (e) => {
      if (!this.lightbox?.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeLightbox();
      }
      if (e.key === 'ArrowLeft') this.goTo(this.cur - 1, true);
      if (e.key === 'ArrowRight') this.goTo(this.cur + 1, true);
      if (e.key === 'Tab') this.trapFocus(e);
    });
  }

  goTo(i, keepLightbox = false) {
    if (!this.images.length) return;
    const len = this.images.length;

    if (this.thumbs[this.cur]) this.thumbs[this.cur].classList.remove('on');
    this.cur = ((i % len) + len) % len;
    if (this.thumbs[this.cur]) this.thumbs[this.cur].classList.add('on');

    const img = this.images[this.cur];
    if (img?.src) {
      this.mainImg.src = img.src;
      this.mainImg.dataset.full = img.full || img.src;
    }

    if (keepLightbox && this.lightboxImg) {
      this.lightboxImg.src = img.full || img.src;
    }
  }

  openLightbox() {
    if (!this.lightbox || !this.lightboxImg || !this.images.length) return;
    this.lastFocused = document.activeElement;
    const img = this.images[this.cur] || this.images[0];
    this.lightboxImg.src = img.full || img.src || this.mainImg.src;
    this.lightbox.setAttribute('aria-hidden', 'false');
    this.lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.lightboxClose?.focus();
  }

  closeLightbox() {
    if (!this.lightbox) return;
    this.lightbox.classList.remove('is-open');
    this.lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (this.lightboxImg) this.lightboxImg.src = '';
    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    } else {
      this.zoomBtn?.focus();
    }
  }

  trapFocus(e) {
    const focusable = $$(this.focusableSelector, this.lightbox).filter(el => !el.disabled && el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
}

/* ============================================================
   PREDICTIVE SEARCH — all results escaped
============================================================ */
class PredictiveSearch {
  constructor() {
    this.input    = $('#search-input');
    this.results  = $('#predictive-results');
    this.clearBtn = $('#search-clear');
    this.openBtn  = $('#search-open');
    this.closeBtn = $('#search-close');
    this.overlay  = $('#search-overlay');
    this.timer    = null;
    this.init();
  }
  init() {
    this.openBtn?.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    this.input?.addEventListener('input', () => {
      clearTimeout(this.timer);
      const q = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.style.display = q ? 'flex' : 'none';
      if (q.length < 2) { if (this.results) this.results.innerHTML = ''; return; }
      this.timer = setTimeout(() => this.search(q), 280);
    });
    this.clearBtn?.addEventListener('click', () => {
      if (this.input) this.input.value = '';
      if (this.results) this.results.innerHTML = '';
      if (this.clearBtn) this.clearBtn.style.display = 'none';
      this.input?.focus();
    });
  }
  open() {
    this.overlay?.setAttribute('aria-hidden', 'false');
    this.overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.input?.focus(), 100);
  }
  close() {
    this.overlay?.setAttribute('aria-hidden', 'true');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  async search(query) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
      const data = await fetch(url).then(r => r.json());
      this.renderResults(data.resources?.results?.products || []);
    } catch { /* silent */ }
  }
  renderResults(products) {
    if (!this.results) return;
    if (!products.length) {
      this.results.innerHTML = '<p class="search-no-results">Nieko neradome</p>';
      return;
    }
    this.results.innerHTML = '<ul class="search-results-list">' +
      products.map(p => {
        const safeTitle = escapeHTML(String(p.title || '').replace('graviiūra', 'graviūra').replace('Graviiūra', 'Graviūra'));
        const safeUrl   = escapeAttr(p.url);
        const safeImg   = p.image ? escapeAttr(p.image) : '';
        return `<li class="search-result-item">
          <a href="${safeUrl}" class="search-result-link">
            <div class="search-result-img">
              ${safeImg ? `<img src="${safeImg}" alt="${safeTitle}" width="50" height="50" loading="lazy"/>` : ''}
            </div>
            <div class="search-result-info">
              <span class="search-result-title">${safeTitle}</span>
              <span class="search-result-price">${safeMoney(p.price)}</span>
            </div>
          </a>
        </li>`;
      }).join('') + '</ul>';
  }
}

/* ============================================================
   WISHLIST
============================================================ */


/* ============================================================
   MOBILE NAV
============================================================ */
function initMobileNav() {
  const burger = $('#burger'), mobNav = $('#mob-nav'), closeBtn = $('#mob-nav-close'), backdrop = $('#mob-nav-backdrop');
  const open  = () => { mobNav?.classList.add('open'); mobNav?.setAttribute('aria-hidden','false'); burger?.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; backdrop?.classList.add('is-visible'); closeBtn?.focus(); };
  const close = () => { mobNav?.classList.remove('open'); mobNav?.setAttribute('aria-hidden','true'); burger?.setAttribute('aria-expanded','false'); document.body.style.overflow=''; backdrop?.classList.remove('is-visible'); };
  burger?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  backdrop?.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
}


function initDesktopDropdowns() {
  $$('[data-dropdown]').forEach(dropdown => {
    const trigger = dropdown.querySelector('.nav-link[aria-haspopup="true"]');
    const menu = dropdown.querySelector('.mega-menu, .nav-dropdown__menu');
    if (!trigger || !menu) return;

    const setOpen = (open) => {
      dropdown.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
    };

    dropdown.addEventListener('mouseenter', () => setOpen(true));
    dropdown.addEventListener('mouseleave', () => setOpen(false));
    trigger.addEventListener('focus', () => setOpen(true));
    dropdown.addEventListener('focusout', (e) => {
      if (!dropdown.contains(e.relatedTarget)) setOpen(false);
    });
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        setOpen(false);
        trigger.focus();
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setOpen(true);
        menu.querySelector('a, button')?.focus();
      }
    });
  });
}

/* ============================================================
   FILTERS
============================================================ */
function initFilters() {
  $$('.fg-hdr').forEach(hdr => {
    hdr.addEventListener('click', () => {
      const fg = hdr.closest('.fg'), body = fg?.querySelector('.fg-body');
      const open = fg?.classList.toggle('open');
      if (body) body.style.display = open ? 'block' : 'none';
    });
  });
  const toggleBtn = $('#filter-toggle-btn'), sidebar = $('#sidebar');
  if (toggleBtn && sidebar) {
    toggleBtn.addEventListener('click', () => {
      const v = sidebar.classList.toggle('visible');
      toggleBtn.setAttribute('aria-expanded', String(v));
    });
  }
  const filterForm = $('#filter-form');
  if (filterForm) {
    filterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(filterForm).entries()) {
        if (value !== '') params.append(key, value);
      }
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }
  const sortSelect = $('#sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }
}

/* ============================================================
   ACCORDION
============================================================ */
function initAccordion() {
  $$('.acc-hdr').forEach(hdr => {
    hdr.addEventListener('click', () => {
      const item = hdr.closest('.acc-item'), body = item?.querySelector('.acc-body');
      const open = item?.classList.toggle('open');
      if (body) body.style.display = open ? 'block' : 'none';
    });
  });
}

/* ============================================================
   RELATED PRODUCTS — escaped output
============================================================ */
async function initRelatedProducts() {
  const container = $('#related-products');
  if (!container) return;
  const productId = container.dataset.productId;
  if (!productId) return;
  try {
    const data = await fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=related`).then(r => r.json());
    if (!data.products?.length || data.products.length < 2) {
      const section = container.closest('.pdp-related-inline');
      if (section && container.children.length < 2) section.style.display = 'none';
      return;
    }
    container.innerHTML = data.products.map(p => {
      const safeTitle = escapeHTML(p.title);
      const safeUrl   = escapeAttr(p.url || p.online_store_url || '#');
      const imgCandidate =
        p.featured_image?.url ||
        p.featured_image ||
        p.image ||
        p.images?.[0]?.src ||
        p.images?.[0] ||
        '';
      const safeImg = imgCandidate ? escapeAttr(imgCandidate) : '';
      return `
        <div class="prod-card">
          <div class="prod-card__img">
            ${safeImg ? `<img class="prod-card__img-el" src="${safeImg}" alt="${safeTitle}" width="600" height="600" loading="lazy"/>` : '<div class="prod-card__img-placeholder"></div>'}
          </div>
          <div class="prod-card__body">
            <div class="prod-card__title"><a href="${safeUrl}">${safeTitle}</a></div>
            <div class="prod-card__price-wrap">
              <span class="prod-card__price">${safeMoney(p.variants?.[0]?.price || p.price)}</span>
            </div>
          </div>
        </div>`;
    }).join('');
  } catch { /* silent */ }
}


function initRelatedControls() {
  const grid = $('#related-products');
  const prev = $('#rel-prev');
  const next = $('#rel-next');
  if (!grid) return;
  const step = () => Math.max(220, grid.clientWidth * 0.8);
  prev?.addEventListener('click', () => grid.scrollBy({ left: -step(), behavior: 'smooth' }));
  next?.addEventListener('click', () => grid.scrollBy({ left: step(), behavior: 'smooth' }));
}

/* ============================================================
   GIFT BUILDER ("Sukurti asmeninę dovaną")
============================================================ */
class GiftBuilder {
  constructor(root) {
    this.root = root;
    this.product = $('[data-gb-product].on', root) || $('[data-gb-product]', root);
    this.occasion = $('[data-gb-occasion].on', root) || null;
    this.addonState = new Map();

    this.productEls = $$('[data-gb-product]', root);
    this.occasionEls = $$('[data-gb-occasion]', root);
    this.addonEls = $$('[data-gb-addon]', root);

    this.previewImg = $('[data-gb-preview-img]', root);
    this.summaryList = $('[data-gb-summary]', root);
    this.baseRow = $('[data-gb-summary-base]', root);
    this.baseLabel = $('[data-gb-summary-base-label]', root);
    this.basePrice = $('[data-gb-summary-base-price]', root);
    this.totalEl = $('[data-gb-total]', root);
    this.addBtn = $('[data-gb-add]', root);

    this.stickyBar = $('[data-gb-sticky-bar]', root);
    this.stickyTotal = $('[data-gb-sticky-total]', root);
    this.stickyAddBtn = $('[data-gb-add-sticky]', root);

    this.bind();
    this.recalculate();
    this.initStickyBar();
  }

  bind() {
    this.productEls.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.productEls.forEach((b) => { b.classList.remove('on'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('on');
        btn.setAttribute('aria-checked', 'true');
        this.product = btn;
        this.updatePreviewImage();
        this.recalculate();
      });
    });

    this.occasionEls.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.occasionEls.forEach((b) => { b.classList.remove('on'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('on');
        btn.setAttribute('aria-checked', 'true');
        this.occasion = btn;
      });
    });

    this.addonEls.forEach((wrap) => {
      const toggle = $('[data-gb-addon-toggle]', wrap);
      const field = $('.gb-addon__field', wrap);
      const textarea = $('[data-gb-text]', wrap);
      const counter = $('[data-gb-count]', wrap);
      if (!toggle) return;

      const sync = () => {
        if (field) field.hidden = !toggle.checked;
        this.addonState.set(toggle.dataset.key + ':' + (toggle.dataset.label || ''), {
          checked: toggle.checked,
          label: toggle.dataset.label || '',
          price: parseFloat(toggle.dataset.price || '0') || 0,
          key: toggle.dataset.key || '',
          text: textarea ? textarea.value.trim() : ''
        });
        this.updatePreviewText(toggle.dataset.key, toggle.checked && textarea ? textarea.value.trim() : '');
        this.recalculate();
      };

      toggle.addEventListener('change', sync);

      if (textarea) {
        textarea.addEventListener('input', () => {
          if (counter) counter.textContent = `${textarea.value.length}/${textarea.maxLength}`;
          this.updatePreviewText(toggle.dataset.key, toggle.checked ? textarea.value.trim() : '');
          sync();
        });
      }

      sync();
    });

    this.addBtn?.addEventListener('click', () => this.addToCart());
    this.stickyAddBtn?.addEventListener('click', () => this.addToCart());
  }

  updatePreviewImage() {
    if (!this.previewImg || !this.product) return;
    const img = this.product.dataset.image;
    if (img) this.previewImg.style.backgroundImage = `url(${img})`;
  }

  updatePreviewText(key, text) {
    const target = $(`[data-gb-preview-field="${key}"]`, this.root);
    if (!target) return;
    if (text) {
      target.textContent = text;
      target.hidden = false;
    } else {
      target.hidden = true;
      target.textContent = '';
    }
  }

  basePriceValue() {
    return this.product ? (parseFloat(this.product.dataset.basePrice) || 0) : 0;
  }

  recalculate() {
    const base = this.basePriceValue();
    let total = base;
    const rows = [];

    if (this.baseLabel && this.product) this.baseLabel.textContent = this.product.dataset.label || '';
    if (this.basePrice) this.basePrice.textContent = money(Math.round(base * 100));

    this.addonState.forEach((addon) => {
      if (!addon.checked) return;
      total += addon.price;
      rows.push(addon);
    });

    if (this.summaryList) {
      $$('.gb-summary__row[data-gb-addon-row]', this.summaryList).forEach((el) => el.remove());
      rows.forEach((addon) => {
        const row = document.createElement('li');
        row.className = 'gb-summary__row';
        row.dataset.gbAddonRow = '';
        const name = document.createElement('span');
        name.textContent = addon.label;
        const price = document.createElement('span');
        price.textContent = addon.price > 0 ? `+${money(Math.round(addon.price * 100))}` : '';
        row.append(name, price);
        this.summaryList.appendChild(row);
      });
    }

    const totalCents = Math.round(total * 100);
    if (this.totalEl) this.totalEl.textContent = money(totalCents);
    if (this.stickyTotal) this.stickyTotal.textContent = money(totalCents);
  }

  initStickyBar() {
    if (!this.stickyBar) return;
    const onScroll = () => {
      const rect = this.root.getBoundingClientRect();
      const visible = rect.top < window.innerHeight && rect.bottom > 0;
      this.stickyBar.hidden = !visible || window.innerWidth > 860;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  async addToCart() {
    if (!this.product) {
      window.svilaCart?.showToast?.(this.root.dataset.i18nSelectGiftFirst || 'Pirmiausia pasirinkite dovaną', 'error');
      return;
    }
    const variantId = Number(this.product.dataset.variantId);
    if (!variantId) return;

    const properties = {};
    if (this.occasion) {
      properties[this.root.dataset.i18nOccasionProperty || 'Proga'] = this.occasion.dataset.label;
    }
    this.addonState.forEach((addon) => {
      if (addon.checked && addon.text) properties[addon.label] = addon.text;
      else if (addon.checked) properties[addon.label] = this.root.dataset.i18nYes || 'Taip';
    });

    [this.addBtn, this.stickyAddBtn].forEach((btn) => { if (btn) btn.disabled = true; });
    try {
      await window.svilaCart?.add(variantId, 1, properties);
    } finally {
      [this.addBtn, this.stickyAddBtn].forEach((btn) => { if (btn) btn.disabled = false; });
    }
  }
}

function initGiftBuilder() {
  $$('[data-gift-builder]').forEach((root) => new GiftBuilder(root));
}

/* ============================================================
   INIT
============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  window.svilaCart = new SvilaCart();
  const productForm = $('#product-form');
  if (productForm) {
    new ProductForm(productForm);
    new ProductGallery();
    initRelatedProducts();
    initRelatedControls();
  }
  new PredictiveSearch();
  new Wishlist();
  initMobileNav();
  initDesktopDropdowns();
  initFilters();
  initAccordion();
  initGiftBuilder();
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
});


window.addEventListener('storage', (event) => {
  if (!event.key || !event.key.toLowerCase().includes('wishlist')) return;
  document.dispatchEvent(new CustomEvent('wishlist:sync', { detail: { key: event.key, value: event.newValue } }));
});

document.addEventListener('wishlist:sync', () => {
  document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
    try {
      const raw = localStorage.getItem('svila_wishlist') || '[]';
      const items = JSON.parse(raw);
      node.textContent = Array.isArray(items) ? String(items.length) : '0';
    } catch (error) {
      node.textContent = '0';
    }
  });
});
/* wishlist:external-refresh */

/* svilaFormatMoneyFallback */

document.addEventListener('DOMContentLoaded', updateWishlistHeaderCount);








/* ===== SVILA WISHLIST ICON + PDP FIX ===== */
(function(){
  const KEY = 'svila_wishlist';
  const qsa = (sel, root=document) => Array.from(root.querySelectorAll(sel));
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (ch) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const attr = (value) => esc(value).replace(/`/g, '&#96;');

  function handleFromUrl(value) {
    return String(value || '').replace('/products/','').split('?')[0].split('/').filter(Boolean).pop() || '';
  }

  function normalize(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const productId = raw.productId || raw.product_id || raw.id || '';
    const handle = raw.handle || raw.productHandle || raw.product_handle || handleFromUrl(raw.url || raw.href || '');
    if (!handle) return null;
    return {
      id: productId ? `id:${productId}` : `handle:${handle}`,
      productId: String(productId || ''),
      handle,
      title: raw.title || raw.productTitle || raw.product_title || handle,
      url: raw.url || raw.href || `/products/${handle}`,
      image: raw.image || raw.featured_image || raw.featuredImage || raw.img || '',
      price: raw.priceText || raw.price_text || raw.price || ''
    };
  }

  function read() {
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      const arr = Array.isArray(parsed) ? parsed : (parsed && Array.isArray(parsed.items) ? parsed.items : []);
      const map = new Map();
      arr.forEach((raw) => {
        const item = normalize(raw);
        if (item && item.id && !map.has(item.id)) map.set(item.id, item);
      });
      const items = Array.from(map.values());
      if (items.length !== arr.length) localStorage.setItem(KEY, JSON.stringify(items));
      return items;
    } catch(e) {
      return [];
    }
  }

  function save(items) {
    const map = new Map();
    items.forEach((raw) => {
      const item = normalize(raw);
      if (item && item.id && !map.has(item.id)) map.set(item.id, item);
    });
    const next = Array.from(map.values());
    localStorage.setItem(KEY, JSON.stringify(next));
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
    return next;
  }

  function itemFromButton(btn) {
    return normalize({
      id: btn.dataset.wishlistId || btn.dataset.productId || btn.dataset.id || '',
      productId: btn.dataset.wishlistId || btn.dataset.productId || btn.dataset.id || '',
      handle: btn.dataset.wishlistHandle || btn.dataset.handle || btn.dataset.productHandle || '',
      title: btn.dataset.wishlistTitle || btn.dataset.title || '',
      url: btn.dataset.wishlistUrl || '',
      image: btn.dataset.wishlistImage || '',
      price: btn.dataset.wishlistPrice || ''
    });
  }

  function updateCount() {
    const count = read().length;
    qsa('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(count);
      el.hidden = count <= 0;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateButtons() {
    const items = read();
    qsa('[data-wishlist], .js-wishlist').forEach((btn) => {
      if (btn.matches('a.wishlist-header-btn[href], a[href="/pages/megstami"]')) return;
      const item = itemFromButton(btn);
      const active = item && items.some((saved) => saved.id === item.id);
      btn.classList.toggle('is-active', !!active);
      btn.classList.toggle('active', !!active);
      btn.setAttribute('aria-pressed', String(!!active));
      btn.setAttribute('aria-label', active ? 'Pašalinti iš mėgstamų' : 'Pridėti prie mėgstamų');
    });
  }

  function toast(message) {
    let node = document.querySelector('[data-svila-toast]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'svila-toast';
      node.setAttribute('data-svila-toast', '');
      document.body.appendChild(node);
    }
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(window.__svilaToastTimer);
    window.__svilaToastTimer = setTimeout(() => node.classList.remove('is-visible'), 1800);
  }

  function bindButtons() {
    qsa('[data-wishlist], .js-wishlist').forEach((btn) => {
      if (btn.matches('a.wishlist-header-btn[href], a[href="/pages/megstami"]')) return;
      if (btn.dataset.safeWishlistBound === 'true') return;

      btn.dataset.safeWishlistBound = 'true';
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const item = itemFromButton(btn);
        if (!item) return;

        const items = read();
        const exists = items.some((saved) => saved.id === item.id);
        save(exists ? items.filter((saved) => saved.id !== item.id) : [...items, item]);
        updateButtons();
        renderPage();
        toast(exists ? 'Pašalinta iš mėgstamų' : 'Pridėta į mėgstamus');
      });
    });
  }

  function skeleton(grid) {
    grid.innerHTML = Array.from({length:4}).map(() => `
      <article class="wishlist-page-card wishlist-page-card--skeleton" aria-hidden="true">
        <div class="wishlist-page-card__media"></div>
        <div class="wishlist-page-card__body">
          <div class="skeleton-line skeleton-line--title"></div>
          <div class="skeleton-line skeleton-line--short"></div>
        </div>
      </article>
    `).join('');
  }

  function renderPage() {
    const grid = document.querySelector('[data-wishlist-page-grid]');
    if (!grid) return;

    const empty = document.querySelector('[data-wishlist-page-empty]');
    const summary = document.querySelector('[data-wishlist-summary]');
    const items = read();

    grid.setAttribute('aria-busy', 'true');
    skeleton(grid);

    window.setTimeout(() => {
      if (!items.length) {
        grid.innerHTML = '';
        grid.setAttribute('aria-busy', 'false');
        if (empty) empty.hidden = false;
        if (summary) summary.textContent = 'Kol kas neturite išsaugotų prekių.';
        return;
      }

      grid.innerHTML = '';
      grid.setAttribute('aria-busy', 'false');
      if (empty) empty.hidden = true;
      if (summary) summary.textContent = `Išsaugota prekių: ${items.length}`;

      items.forEach((item) => {
        const title = esc(item.title || item.handle || 'Mėgstama prekė');
        const url = attr(item.url || `/products/${item.handle}`);
        const image = attr(item.image || '');
        const price = esc(item.price || '');
        const id = attr(item.id);

        const card = document.createElement('article');
        card.className = 'wishlist-page-card';
        card.innerHTML = `
          ${image
            ? `<a class="wishlist-page-card__media" href="${url}"><img src="${image}" alt="${title}" loading="lazy"></a>`
            : `<a class="wishlist-page-card__media wishlist-page-card__media--empty" href="${url}" aria-label="${title}"><span aria-hidden="true">♡</span></a>`}
          <div class="wishlist-page-card__body">
            <h3><a href="${url}">${title}</a></h3>
            ${price ? `<p class="wishlist-page-card__price">${price}</p>` : ''}
            <div class="wishlist-page-card__actions">
              <a class="btn btn-secondary" href="${url}">Peržiūrėti</a>
              <button type="button" class="btn btn-ghost" data-wishlist-remove-id="${id}">Pašalinti</button>
            </div>
          </div>
        `;
        grid.appendChild(card);
      });

      qsa('[data-wishlist-remove-id]', grid).forEach((btn) => {
        btn.addEventListener('click', () => {
          save(read().filter((item) => item.id !== btn.dataset.wishlistRemoveId));
          updateButtons();
          renderPage();
        });
      });
    }, 80);
  }

  function init() {
    bindButtons();
    updateCount();
    updateButtons();
    renderPage();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('wishlist:updated', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    init();
  });

  window.svilaWishlistSafe = { read, save, renderPage, updateCount, updateButtons };
})();


/* ===== SVILA PRODUCT GALLERY ONE-CLICK FIX ===== */
(function(){
  function openLightboxFrom(src, alt){
    const lightbox = document.querySelector('.p-lightbox, .product-lightbox, [data-product-lightbox]');
    const lightboxImg = lightbox ? lightbox.querySelector('img') : null;

    if (lightbox && lightboxImg && src) {
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      const close = lightbox.querySelector('button, [data-close-lightbox], .lightbox-close');
      if (close) close.focus();
      return true;
    }

    const zoomButton = document.querySelector('.gal-zoom, [data-gallery-zoom], [data-open-lightbox]');
    if (zoomButton) {
      zoomButton.click();
      return true;
    }

    return false;
  }

  function initSvilaGalleryOneClick(){
    document.querySelectorAll('.gal-main img, [data-main-image], .product-gallery__main img').forEach((img) => {
      if (img.dataset.oneClickGalleryBound === 'true') return;
      img.dataset.oneClickGalleryBound = 'true';
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const full = img.dataset.full || img.dataset.zoom || img.currentSrc || img.src;
        openLightboxFrom(full, img.alt);
      });
    });

    document.querySelectorAll('.gal-main, .product-gallery__main').forEach((wrap) => {
      if (wrap.dataset.oneClickGalleryWrapBound === 'true') return;
      wrap.dataset.oneClickGalleryWrapBound = 'true';
      wrap.addEventListener('click', (event) => {
        const interactive = event.target.closest('button, a, .gal-arr, .gal-zoom');
        if (interactive) return;
        const img = wrap.querySelector('img');
        if (!img) return;
        event.preventDefault();
        const full = img.dataset.full || img.dataset.zoom || img.currentSrc || img.src;
        openLightboxFrom(full, img.alt);
      });
    });

    document.querySelectorAll('.g-thumb, [data-gallery-thumb], .product-gallery__thumb').forEach((thumb) => {
      if (thumb.dataset.oneClickThumbBound === 'true') return;
      thumb.dataset.oneClickThumbBound = 'true';
      thumb.addEventListener('click', () => {
        window.setTimeout(() => {
          const img = document.querySelector('.gal-main img, [data-main-image], .product-gallery__main img');
          if (img) img.style.cursor = 'zoom-in';
        }, 20);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initSvilaGalleryOneClick);
  document.addEventListener('shopify:section:load', initSvilaGalleryOneClick);
})();


/* ===== SVILA ACCORDION REAL HTML FIX ===== */
(function(){
  function initProductAccordions(){
    document.querySelectorAll('[data-product-accordion] .acc-item').forEach((item) => {
      const header = item.querySelector('.acc-hdr');
      const body = item.querySelector('.acc-body');
      if (!header || !body) return;

      if (header.dataset.accordionBound === 'true') return;
      header.dataset.accordionBound = 'true';

      const setOpen = (open) => {
        item.classList.toggle('is-open', open);
        header.setAttribute('aria-expanded', String(open));
        body.hidden = !open;
        body.style.display = open ? 'block' : 'none';
        body.style.visibility = open ? 'visible' : '';
        body.style.opacity = open ? '1' : '';
        body.style.maxHeight = open ? 'none' : '';
      };

      setOpen(item.classList.contains('is-open') || header.getAttribute('aria-expanded') === 'true');

      header.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(header.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initProductAccordions);
  document.addEventListener('shopify:section:load', initProductAccordions);
})();
